import Grid from "@mui/material/Grid";
import MDBox from "../../../components/MDBox";

import ReportsLineChart from "./Charts/LineCharts/ReportsLineChart";

import { useTranslation } from "react-i18next";
function SalesGraph(props) {
  const { t }     = useTranslation();
  const graphData = props.graphData;


  return (
    <MDBox mt={4.5}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <MDBox mb={3}>
            <ReportsLineChart
              color="secondary"
              title={t("Monthly Sales")}           
              chart={graphData}
            />
          </MDBox>
        </Grid>  
      </Grid>
    </MDBox>
  )
}

export default SalesGraph;